import React from 'react';
import './reportAnswerLikertScale.scss';
import {QuestionReport} from '../../../../analytics';

export const likertScaleReportsColors = [
    '#1B7A35',
    '#66E0E5',
    '#2563EB',
    '#A9CFFF',
    '#6B7280',
    '#F5D85A',
    '#A94800',
    '#FFD0B8',
    '#B91C1C',
    '#FFB0D0',
];

interface ReportAnswerLikertScaleProps {
    questionReport: QuestionReport;
    likertQuestions?: {id: string; text: string}[];
    visibilityLimit?: number;
}

function ReportAnswerLikertScale({
    questionReport,
    likertQuestions,
    visibilityLimit = 0.05,
}: ReportAnswerLikertScaleProps): JSX.Element | null {
    const likertScaleData = questionReport.likertScaleData || [];
    const rows = likertQuestions?.length
        ? likertQuestions.map((question) => ({
              text: question.text,
              data: likertScaleData.find((data) => data.questionId === question.id),
          }))
        : likertScaleData.map((data) => ({text: data.questionText.toString(), data}));
    const questions = rows.map((row) => row.text);
    const scales = questionReport.answers.map((scale) => scale.answerText) || [];
    const scaleLength = questionReport.answers.length;
    const scaleTotals: number[] = new Array(scaleLength).fill(0);
    let allResponses = 0;
    const percentages = rows.map(({data: questionData}) => {
        const scaleCounts = scales.map((scale) => {
            const value = questionData?.[scale];
            return typeof value === 'number' ? value : 0;
        });
        const totalResponses = scaleCounts.reduce((sum, count) => sum + count, 0);

        scaleCounts.forEach((count, i) => {
            scaleTotals[i] += count;
        });
        allResponses += totalResponses;

        return scaleCounts.map((count) => (totalResponses > 0 ? count / totalResponses : 0));
    });
    const scalePercentages = scaleTotals.map((count) => (allResponses > 0 ? Math.round((count * 100) / allResponses) : 0));

    return (
        <div className="c-reportAnswerLikertScale">
            {questions.map((question, index) => {
                const questionPercentages = percentages[index];
                return (
                    <div key={index} className="c-reportAnswerLikertScale__question">
                        <div className="c-reportAnswerLikertScale__question">{question}</div>
                        <div className="c-reportAnswerLikertScale__answers">
                            {questionPercentages?.map((percentage, answerIndex) => (
                                <div
                                    key={answerIndex}
                                    style={{
                                        width: `${percentage * 100}%`,
                                        backgroundColor: `${likertScaleReportsColors[answerIndex % likertScaleReportsColors.length]}`,
                                    }}
                                    className="c-reportAnswerLikertScale__answers_answer"
                                />
                            ))}
                        </div>
                        <div className="c-reportAnswerLikertScale__percentages">
                            {questionPercentages?.map((percentage, answerIndex) => (
                                <div
                                    key={answerIndex}
                                    style={{
                                        width: `${percentage * 100}%`,
                                        visibility: percentage >= visibilityLimit ? 'visible' : 'hidden',
                                    }}
                                    className="c-reportAnswerLikertScale__percentages_item"
                                >
                                    {Math.round(percentage * 100)}%
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
            <div className="c-reportAnswerLikertScale__legend">
                {scales.map((scale, index) => (
                    <div key={index} className="c-reportAnswerLikertScale__legend_item">
                        <div
                            className="c-reportAnswerLikertScale__legend_circle"
                            style={{backgroundColor: likertScaleReportsColors[index % likertScaleReportsColors.length]}}
                        />
                        <div>{scale}</div>
                        <div className="c-reportAnswerLikertScale__legend_percentage">{scalePercentages[index]}%</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
export default ReportAnswerLikertScale;
